import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.onClick = this.onClick.bind(this);
    this.element.addEventListener("click", this.onClick);
    this.feedbackTimeouts = new WeakMap();
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick);
  }

  async onClick(event) {
    const trigger = event.target.closest("[data-copy-on-click-target-id]");
    if (!trigger || !this.element.contains(trigger)) return;

    const targetId = trigger.dataset.copyOnClickTargetId;
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    const text = this.extractText(target);
    if (!text) return;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        this.showFeedback(trigger);
        return;
      }
    } catch (_) {
      // Fall back to document.execCommand below.
    }

    this.execCopyFallback(target, text);
    this.showFeedback(trigger);
  }

  extractText(target) {
    if ("value" in target && typeof target.value === "string") {
      return target.value;
    }
    return target.textContent?.trim() || "";
  }

  execCopyFallback(_target, text) {
    const temp = document.createElement("textarea");
    temp.value = text;
    temp.setAttribute("readonly", "");
    temp.style.position = "fixed";
    temp.style.left = "-9999px";
    temp.style.opacity = "0";
    document.body.appendChild(temp);
    temp.focus();
    temp.select();
    document.execCommand("copy");
    temp.remove();
  }

  showFeedback(trigger) {
    const label = trigger.querySelector("[data-copy-on-click-label]");
    const icon = trigger.querySelector("[data-copy-on-click-icon]");
    const originalText = trigger.dataset.copyOnClickOriginalText;
    const feedbackText = trigger.dataset.copyOnClickFeedbackText;
    const originalIcon = trigger.dataset.copyOnClickOriginalIcon;
    const feedbackIcon = trigger.dataset.copyOnClickFeedbackIcon;

    if (!label || !feedbackText) return;

    const existingTimeout = this.feedbackTimeouts.get(trigger);
    if (existingTimeout) clearTimeout(existingTimeout);

    label.textContent = feedbackText;
    if (icon && feedbackIcon) {
      icon.classList.remove(`ti-${originalIcon || "copy"}`);
      icon.classList.add(`ti-${feedbackIcon}`);
    }

    const timeoutId = window.setTimeout(() => {
      label.textContent = originalText || "";
      if (icon && feedbackIcon) {
        icon.classList.remove(`ti-${feedbackIcon}`);
        icon.classList.add(`ti-${originalIcon || "copy"}`);
      }
      this.feedbackTimeouts.delete(trigger);
    }, 1500);

    this.feedbackTimeouts.set(trigger, timeoutId);
  }
}
